<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/64GdW5/tc-custom/9781507134511.jpg?1650526862012" alt="This image is the cover for the book La Terre Vorace - Livre Élémentaire II"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">La Terre Vorace - Livre Élémentaire II
      </h1>
      <p class="bookDescription body article font2">
        <p>Devon Sanders, un détective privé réputé pour son efficacité et sa discrétion, a décidé de devenir un sorcier accompli. Il retourne donc à l’université paranormale afin d’y apprendre la magie et de découvrir l’histoire de l’étrange château. Mais c’était sans compter sur ce que lui réservait ce nouveau semestre à Quintessence.<br/> Quand un étudiant meurt sans cause apparente, la recherche d’un témoin mène Devon à la découverte de secrets inattendus, enfouis dans les profonds sous-sols de l’université. Pour sauver le monde paranormal dont il fait désormais partie, il devra affronter un ennemi capable de retourner ses propres pouvoirs contre lui. Pour résoudre cette affaire, Devon va devoir se fier à bien plus qu’à sa seule intuition exceptionnelle.<br/> Plongez au cœur de la magie élémentaire.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rain Oxford, Camille Fankhauser
      </h2>
      
      <p class="authorDescription body article">Enseignante et écrivaine, Rain Oxford, a passé plus de la moitié de sa vie à écrire. Les cultures d’influence asiatique auxquelles elle donne vie dans ses textes sont inspirées du temps qu’elle a passé à Kyoto en tant qu’étudiante à l’Université de Ritsumeikan.<br/> Rain Oxford écrit la plupart de ses romans dans un chalet isolé dans la forêt, avec pour seule compagnie un petit bichon maltais. Quand elle n’est pas en train d’enseigner ou de créer des univers fantastiques, elle aime cuisiner, jouer du piano et photographier des animaux exotiques.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d15c18ec